const DEFAULT_TIMEOUT = 10000

function toNumber(value, fallback) {
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback
}

function toBoolean(value, fallback = false) {
  if (value === true || value === 'true') {
    return true
  }
  if (value === false || value === 'false') {
    return false
  }
  return fallback
}

function isPlaceholder(value) {
  return typeof value === 'string' && /^\$\{[^}]+\}$/.test(value.trim())
}

function readEnv(key) {
  if (typeof window !== 'undefined') {
    const runtime = window.__APP_CONFIG__
    if (runtime && Object.prototype.hasOwnProperty.call(runtime, key)) {
      const value = runtime[key]
      if (value !== undefined && value !== null && value !== '' && !isPlaceholder(value)) {
        return value
      }
    }
  }
  return import.meta.env[key]
}

function normalizeApiBaseUrl(rawValue) {
  if (typeof rawValue !== 'string') {
    return ''
  }
  const value = rawValue.trim().replace(/\/$/, '')
  if (!value) {
    return ''
  }
  if (!/^https?:\/\//i.test(value)) {
    return value
  }
  let parsed
  try {
    parsed = new URL(value)
  } catch {
    return value
  }
  const hostname = parsed.hostname
  const isClusterInternal =
    (!hostname.includes('.') && hostname !== 'localhost') ||
    hostname.endsWith('.svc') ||
    hostname.endsWith('.cluster.local') ||
    hostname.endsWith('.svc.cluster.local')
  if (!isClusterInternal) {
    return value
  }
  const pathname = (parsed.pathname || '').replace(/\/$/, '')
  return pathname
}

function encodeAssetUrl(value) {
  try {
    return encodeURI(decodeURI(value))
  } catch {
    return encodeURI(value)
  }
}

export const appConfig = {
  appTitle: readEnv('VITE_APP_TITLE') || 'Cipopo 官网',
  apiBaseUrl: normalizeApiBaseUrl(readEnv('VITE_API_BASE_URL')),
  apiPrefix: readEnv('VITE_API_PREFIX') || '/api/v1',
  appCode: readEnv('VITE_APP_CODE') || 'cipopo-web',
  appId: readEnv('VITE_APP_ID') || readEnv('VITE_APP_CODE') || 'cipopo-web',
  appVersion: readEnv('VITE_APP_VERSION') || '0.0.0',
  clientType: readEnv('VITE_CLIENT_TYPE') || 'web-site',
  requestTimeout: toNumber(readEnv('VITE_REQUEST_TIMEOUT'), DEFAULT_TIMEOUT),
  enableLog: toBoolean(readEnv('VITE_ENABLE_LOG'), false),
  downloadUrls: {
    ios:
      readEnv('VITE_DOWNLOAD_URL_IOS') ||
      'https://apps.apple.com/cn/app/id6760641557',
    android:
      readEnv('VITE_DOWNLOAD_URL_ANDROID') ||
      'https://appgallery.huawei.com/app/C118488605',
    androidApk:
      readEnv('VITE_DOWNLOAD_URL_ANDROID_APK') ||
      'https://app-download.joyin-ai.com/Me2/release/1.0.6/20261022-154007/app-uploadCOS-release.apk',
    harmonyos:
      readEnv('VITE_DOWNLOAD_URL_HARMONYOS') ||
      'https://appgallery.huawei.com/app/detail?id=com.zeroth.hmos.me2robot&channelId=SHARE&source=appshare',
  },
  downloadQrImageUrls: {
    ios: encodeAssetUrl(
      readEnv('VITE_DOWNLOAD_QR_IMAGE_URL_IOS') || '/App Store下载二维码.png',
    ),
    harmonyos: encodeAssetUrl(
      readEnv('VITE_DOWNLOAD_QR_IMAGE_URL_HARMONYOS') ||
        readEnv('VITE_DOWNLOAD_QR_IMAGE_URL') ||
        '/鸿蒙应用商城下载二维码.png',
    ),
    android: encodeAssetUrl(
      readEnv('VITE_DOWNLOAD_QR_IMAGE_URL_ANDROID') ||
        '/Android安装包下载二维码.png',
    ),
  },
  icpRecord: readEnv('VITE_ICP_RECORD') || '',
  icpRecordUrl: readEnv('VITE_ICP_RECORD_URL') || 'https://beian.miit.gov.cn/',
  manualPdfUrl:
    readEnv('VITE_MANUAL_PDF_URL') ||
    encodeURI('/电子说明书.pdf'),
}
